import { render } from "./index.vue?vue&type=template&id=b1aa9214&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=b1aa9214&lang=css"
import "./index.vue?vue&type=style&index=1&id=b1aa9214&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1aa9214"]])

export default __exports__